import { HostListener, Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { SimpleModalComponent } from "../services/sepidzmodal/simple-modal.component";

@Injectable()
export abstract class ComponentCanDeactivate  extends SimpleModalComponent<ConfirmModel, any> implements ConfirmModel {
  abstract canDeactivate(): boolean | Observable<boolean>;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent) {
    if (!this.canDeactivate()) {
      //$event.preventDefault();
      //$event.returnValue = true;
      $event.preventDefault();
      $event.returnValue = "شما اطلاعات ذخیره نشده دارید! در صورت خروج اطلاعات از دست خواهد رفت.";
    }
  }
}
export interface ConfirmModel {
//  title:string;
}
